import { jsx as r } from "react/jsx-runtime";
import i from "./index.es5454.js";
import { Link as t } from "./index.es62.js";
const s = ({ children: o, onClick: e }) => /* @__PURE__ */ r("div", { className: i.root, onClick: e, children: /* @__PURE__ */ r(t, { hideUnderline: !0, color: "brand", size: "small", weight: "regular", children: o }) });
export {
  s as SectionMore
};
//# sourceMappingURL=index.es5453.js.map
